import { Href } from "~/shared/ui"

import cssModule from "./index.module.css"
import { ComponentProps } from "react"

const contactAccordionItemRootElementProps = {
	style: {
		//padding: "0.5rem 1rem",
		borderTopRightRadius: "0",
		borderTopLeftRadius: "0",
		borderTop: "1px solid #00000020"
	}
}

/** Контакты */
export type ContactsType = {
	/** Заголовок */
	title?: string
	/** Список номеров телефонов */
	phones?: string[]
	/** Список локальных номеров телефонов */
	localPhones?: string[]
	/** E-Mail */
	email?: string
	/** Место нахождения (например, кабинет) */
	place?: string
	/** ФИО */
	person?: string
	/** Сайт */
	url?: string
}

/** Блок для отображения контактов */
export function Contacts({ url, title, person, place, localPhones, phones, email, ...props } : ComponentProps<'div'> & ContactsType) {

	return (
		<div className={cssModule.contactCss} {...props}>
			<div {...contactAccordionItemRootElementProps}>
				<h4 className="pr-[0rem] pl-[0.5rem] pt-[1rem] pb-[0.5rem] ml-[1.25rem]">
					Контакты
				</h4>
			</div>
			<div className="ml-[1.7rem] pb-[1em]">
				{title && <div>
					{url
						? <Href
							style={{ textDecoration: "underline" }}
							href={url}
						>
							{title}
						</Href>
						: title}
				</div>}
				{phones && (
					<div>
						Тел.:{" "}
						{phones.map((phone) => (
							<a
								key={phone}
								className={cssModule.contactHref}
								href={`tel:${phone}`}
							>
								{phone}
							</a>
						))}
					</div>
				)}
				{localPhones && (
					<div>
						Местн. тел.:{" "}
						{localPhones.map((phone) => (
							<span key={phone}>{phone}</span>
						))}
					</div>
				)}
				{email && (
					<div>
						E-mail:{" "}
						<a className={cssModule.contactHref} href={email}>
							{email}
						</a>
					</div>
				)}
				{person && <div>{person}</div>}
				{place && <div>Размещение: {place}</div>}
			</div>
		</div>
	)
}
